// One-series shape summary, oldest to newest. The exact numbers always sit
// beside it (table rows, card text), so the glyph is decorative: aria-hidden,
// no axes, no tooltip — the adjacent text is the accessible reading.

const W = 100;
const H = 28;
const PAD = 3;

export function TrendSparkline({ values, className }: { values: number[]; className?: string }) {
  if (values.length < 2) return null;
  const min = Math.min(...values);
  const span = Math.max(...values) - min || 1;
  const step = (W - PAD * 2) / (values.length - 1);
  const points = values
    .map((value, i) => {
      const x = PAD + i * step;
      const y = H - PAD - ((value - min) / span) * (H - PAD * 2);
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(" ");

  return (
    <svg
      viewBox={`0 0 ${W} ${H}`}
      preserveAspectRatio="none"
      aria-hidden="true"
      className={className}
    >
      <polyline
        points={points}
        fill="none"
        stroke="var(--primary)"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}
